/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { ImageDTO } from "./ImageDTO";
import { ImageDTOFromJSON, ImageDTOFromJSONTyped, ImageDTOToJSON } from "./ImageDTO";
import type { PublicPlatformDTO } from "./PublicPlatformDTO";
import {
  PublicPlatformDTOFromJSON,
  PublicPlatformDTOFromJSONTyped,
  PublicPlatformDTOToJSON
} from "./PublicPlatformDTO";
import type { SeoDTO } from "./SeoDTO";
import { SeoDTOFromJSON, SeoDTOFromJSONTyped, SeoDTOToJSON } from "./SeoDTO";

/**
 *
 * @export
 * @interface OutAdminProductDTO
 */
export interface OutAdminProductDTO {
  /**
   *
   * @type {number}
   * @memberof OutAdminProductDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof OutAdminProductDTO
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof OutAdminProductDTO
   */
  ean?: string;
  /**
   *
   * @type {PublicPlatformDTO}
   * @memberof OutAdminProductDTO
   */
  platform: PublicPlatformDTO;
  /**
   *
   * @type {boolean}
   * @memberof OutAdminProductDTO
   */
  live: boolean;
  /**
   *
   * @type {string}
   * @memberof OutAdminProductDTO
   */
  slug: string;
  /**
   *
   * @type {ImageDTO}
   * @memberof OutAdminProductDTO
   */
  image?: ImageDTO;
  /**
   *
   * @type {SeoDTO}
   * @memberof OutAdminProductDTO
   */
  seo?: SeoDTO;
  /**
   *
   * @type {string}
   * @memberof OutAdminProductDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof OutAdminProductDTO
   */
  specification?: string;
  /**
   *
   * @type {Date}
   * @memberof OutAdminProductDTO
   */
  updatedAt?: Date;
  /**
   *
   * @type {string}
   * @memberof OutAdminProductDTO
   */
  createdAt?: string;
  /**
   * How the page was created (API = automatic sync).
   * @type {string}
   * @memberof OutAdminProductDTO
   */
  createdBy: OutAdminProductDTOCreatedByEnum;
  /**
   *
   * @type {Date}
   * @memberof OutAdminProductDTO
   */
  noDealsSince?: Date | null;
  /**
   * When this live page will be taken offline (noDealsSince + grace). Null when not heading offline.
   * @type {Date}
   * @memberof OutAdminProductDTO
   */
  offlineAt?: Date | null;
  /**
   * When this offline automatic page will be deleted (noDealsSince + 90d). Null when not applicable.
   * @type {Date}
   * @memberof OutAdminProductDTO
   */
  deleteAt?: Date | null;
  /**
   * Who wrote the description. MANUAL locks it: the generator skips the row.
   * @type {string}
   * @memberof OutAdminProductDTO
   */
  descriptionSource?: OutAdminProductDTODescriptionSourceEnum;
  /**
   *
   * @type {Date}
   * @memberof OutAdminProductDTO
   */
  descriptionGeneratedAt?: Date | null;
  /**
   * The model's own 0–1 certainty for the stored description.
   * @type {number}
   * @memberof OutAdminProductDTO
   */
  descriptionConfidence?: number | null;
  /**
   *
   * @type {Date}
   * @memberof OutAdminProductDTO
   */
  descriptionAttemptedAt?: Date | null;
  /**
   * Why the last generation attempt stored nothing.
   * @type {string}
   * @memberof OutAdminProductDTO
   */
  descriptionSkipReason?: OutAdminProductDTODescriptionSkipReasonEnum;
}

/**
 * @export
 */
export const OutAdminProductDTOCreatedByEnum = {
  API: "API",
  DASHBOARD: "DASHBOARD"
} as const;
export type OutAdminProductDTOCreatedByEnum =
  typeof OutAdminProductDTOCreatedByEnum[keyof typeof OutAdminProductDTOCreatedByEnum];

/**
 * @export
 */
export const OutAdminProductDTODescriptionSourceEnum = {
  MANUAL: "MANUAL",
  AI: "AI"
} as const;
export type OutAdminProductDTODescriptionSourceEnum =
  typeof OutAdminProductDTODescriptionSourceEnum[keyof typeof OutAdminProductDTODescriptionSourceEnum];

/**
 * @export
 */
export const OutAdminProductDTODescriptionSkipReasonEnum = {
  LOW_CONFIDENCE: "LOW_CONFIDENCE",
  BAD_LENGTH: "BAD_LENGTH",
  API_ERROR: "API_ERROR"
} as const;
export type OutAdminProductDTODescriptionSkipReasonEnum =
  typeof OutAdminProductDTODescriptionSkipReasonEnum[keyof typeof OutAdminProductDTODescriptionSkipReasonEnum];

/**
 * Check if a given object implements the OutAdminProductDTO interface.
 */
export function instanceOfOutAdminProductDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "live" in value;
  isInstance = isInstance && "slug" in value;
  isInstance = isInstance && "createdBy" in value;

  return isInstance;
}

export function OutAdminProductDTOFromJSON(json: any): OutAdminProductDTO {
  return OutAdminProductDTOFromJSONTyped(json, false);
}

export function OutAdminProductDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutAdminProductDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    title: json["title"],
    ean: !exists(json, "ean") ? undefined : json["ean"],
    platform: PublicPlatformDTOFromJSON(json["platform"]),
    live: json["live"],
    slug: json["slug"],
    image: !exists(json, "image") ? undefined : ImageDTOFromJSON(json["image"]),
    seo: !exists(json, "seo") ? undefined : SeoDTOFromJSON(json["seo"]),
    description: !exists(json, "description") ? undefined : json["description"],
    specification: !exists(json, "specification") ? undefined : json["specification"],
    updatedAt: !exists(json, "updatedAt") ? undefined : new Date(json["updatedAt"]),
    createdAt: !exists(json, "createdAt") ? undefined : json["createdAt"],
    createdBy: json["createdBy"],
    noDealsSince: !exists(json, "noDealsSince")
      ? undefined
      : json["noDealsSince"] === null
      ? null
      : new Date(json["noDealsSince"]),
    offlineAt: !exists(json, "offlineAt") ? undefined : json["offlineAt"] === null ? null : new Date(json["offlineAt"]),
    deleteAt: !exists(json, "deleteAt") ? undefined : json["deleteAt"] === null ? null : new Date(json["deleteAt"]),
    descriptionSource: !exists(json, "descriptionSource") ? undefined : json["descriptionSource"],
    descriptionGeneratedAt: !exists(json, "descriptionGeneratedAt")
      ? undefined
      : json["descriptionGeneratedAt"] === null
      ? null
      : new Date(json["descriptionGeneratedAt"]),
    descriptionConfidence: !exists(json, "descriptionConfidence") ? undefined : json["descriptionConfidence"],
    descriptionAttemptedAt: !exists(json, "descriptionAttemptedAt")
      ? undefined
      : json["descriptionAttemptedAt"] === null
      ? null
      : new Date(json["descriptionAttemptedAt"]),
    descriptionSkipReason: !exists(json, "descriptionSkipReason") ? undefined : json["descriptionSkipReason"]
  };
}

export function OutAdminProductDTOToJSON(value?: OutAdminProductDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    title: value.title,
    ean: value.ean,
    platform: PublicPlatformDTOToJSON(value.platform),
    live: value.live,
    slug: value.slug,
    image: ImageDTOToJSON(value.image),
    seo: SeoDTOToJSON(value.seo),
    description: value.description,
    specification: value.specification,
    updatedAt: value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
    createdAt: value.createdAt,
    createdBy: value.createdBy,
    noDealsSince:
      value.noDealsSince === undefined
        ? undefined
        : value.noDealsSince === null
        ? null
        : value.noDealsSince.toISOString(),
    offlineAt:
      value.offlineAt === undefined ? undefined : value.offlineAt === null ? null : value.offlineAt.toISOString(),
    deleteAt: value.deleteAt === undefined ? undefined : value.deleteAt === null ? null : value.deleteAt.toISOString(),
    descriptionSource: value.descriptionSource,
    descriptionGeneratedAt:
      value.descriptionGeneratedAt === undefined
        ? undefined
        : value.descriptionGeneratedAt === null
        ? null
        : value.descriptionGeneratedAt.toISOString(),
    descriptionConfidence: value.descriptionConfidence,
    descriptionAttemptedAt:
      value.descriptionAttemptedAt === undefined
        ? undefined
        : value.descriptionAttemptedAt === null
        ? null
        : value.descriptionAttemptedAt.toISOString(),
    descriptionSkipReason: value.descriptionSkipReason
  };
}
